import { REQUEST_STATUSES } from "@/constants/index.js";

const initialState = {
  experienceMediaItems: {},
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const experienceMediaItemsSelector = (propertyId, experienceId) => (state) => {
  return {
    ...initialState,
    ...(state.experienceMediaItems[`${propertyId}/${experienceId}`] || {}),
  };
};
